'use client';

import { datadogRum } from '@datadog/browser-rum';
import { DE$ } from '@infl-ts/util-datum';
import * as DE from '@nll/datum/lib/DatumEither';
import { useEffect } from 'react';
import { pipe } from 'fp-ts/function';
import { useProfileQuery } from './queries';
export var DatadogSessionSettings = function DatadogSessionSettings(_ref) {
  var isPagePublic = _ref.isPagePublic;
  datadogRum.onReady(function () {
    var userRole = pipe(useProfileQuery({
      skip: isPagePublic
    }), DE.map(function (_ref2) {
      var _ref2$profile = _ref2.profile,
          isAdmin = _ref2$profile.isAdmin,
          isClone = _ref2$profile.isClone;
      return isAdmin || isClone;
    }), DE$.getSuccessOrElse(false), function (isAdmin) {
      return isAdmin ? 'Admin' : 'Advocate';
    });
    useEffect(function () {
      datadogRum.setGlobalContextProperty('user_role', userRole);
      datadogRum.setGlobalContextProperty('hub_url', window.location.host);
      return function () {
        datadogRum.removeGlobalContextProperty('user_role');
        datadogRum.removeGlobalContextProperty('hub_url');
      };
    }, []);
  });
  return null;
};